import React from "react";
import { Link } from "react-router-dom";
import { useConsultModal } from "@/components/ConsultModal";
import { ArrowRight, Brain, GraduationCap, Buildings, PhoneCall, CalendarBlank, ShoppingBag } from "@phosphor-icons/react";

// Home "Six gentle ways" section — glass cards grid. Extracted from Home.jsx.
const CARDS = [
  { title: "Get Support for Your Mind", desc: "One-to-one support for mental health, cognitive wellbeing, and everyday functioning.", to: "/couch", cta: "Browse Couch", icon: Brain, span: "md:col-span-7 md:row-span-2", hero: true },
  { title: "Navigate Your Psychology Career", desc: "Mentorship and guidance for students and professionals.", to: "/forward", cta: "Browse Forward", icon: GraduationCap, span: "md:col-span-5" },
  { title: "Work With Your Organisation", desc: "Workshops and programmes for schools, universities and companies.", to: "/organisations", cta: "For Organisations", icon: Buildings, span: "md:col-span-5" },
  { title: "Book a Free Consultation", desc: "Speak with Shreeja first at no cost.", action: "consult", cta: "Book Your Free Call", icon: PhoneCall, span: "md:col-span-4" },
  { title: "Come to an Event", desc: "Webinars, workshops and in-person sessions.", to: "/events", cta: "See Events", icon: CalendarBlank, span: "md:col-span-4" },
  { title: "Buy a Resource", desc: "Books and tools to support wellbeing and career development.", to: "/shop", cta: "Visit the Shop", icon: ShoppingBag, span: "md:col-span-4" },
];

export default function HomeHowWeWorkSection() {
  const { open: openConsult } = useConsultModal();

  return (
    <section className="md-section md-section how-we-work-section" data-testid="how-we-work-section" style={{ background: "#ffffff" }}>
      <div className="md-container">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <div className="md-label-eyebrow mb-3">How We Work</div>
          <h2 className="text-4xl md:text-5xl font-serif mb-3">Six gentle ways into MindDhara</h2>
          <p className="text-lg" style={{ color: "var(--md-text-soft)" }}>Choose what feels right. Start where you are. Move when you&apos;re ready.</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {CARDS.map((c, i) => {
            const inner = (
              <>
                <div className="how-glass-ico"><c.icon size={26} weight="duotone" /></div>
                <h3 className="how-glass-title">{c.title}</h3>
                <p className="how-glass-desc">{c.desc}</p>
                <span className="how-glass-cta">{c.cta} <ArrowRight size={12} weight="bold" /></span>
              </>
            );
            if (c.action === "consult") {
              return (
                <button key={c.title} type="button" onClick={openConsult} className="how-glass text-left" data-testid={`how-card-${i}`}>{inner}</button>
              );
            }
            return (
              <Link key={c.title} to={c.to} className="how-glass" data-testid={`how-card-${i}`}>{inner}</Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
